import React from "react";
import EditTravellerForm from './edit-traveller-form';
import { useLocation } from 'react-router-dom';

export default function OrderWrapper(props) {
	const paths = useLocation().pathname.split('/');

	function sidebarOpened() {
		props.updateSidebarOpened(true);
	}

	return (
		<EditTravellerForm currentLoggedInUser={props.currentLoggedInUser} id={paths[paths.length - 1]} capabilities={props.capabilities} onSidebarOpen={sidebarOpened} />
	)
}